export const MERMAID = 'mermaid'
export const COMFORTING_HUMILIATED = 'comfortingHumiliated'
